// extracted by mini-css-extract-plugin
export default {"heading":"adminHome_heading__KdQ4L","table":"adminHome_table__q+nAZ"};